import { Model } from "./Model";
import { SystemSettingGroup } from "./SystemSettingGroup";

export interface SystemSetting extends Model {
	label?: string;
	systemSettingGroup?: SystemSettingGroup;
	systemSettingGroupId: number;
	value: string;
}

export class SystemSetting implements SystemSetting {
	systemSettingGroupId = -1;

	constructor(data?: Partial<SystemSetting>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}